import React, { useState } from 'react';
import { ArrowUpRight, Check } from 'lucide-react';
import { PLANS, SITES_PLANS, WHATSAPP_LINK } from '../data/mock';

export default function Pricing() {
  const [tab, setTab] = useState('social');

  return (
    <section id="precos" className="py-24 md:py-36 relative">
      <div className="thesis-container">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-end border-b border-white/8 pb-8 md:pb-12">
          <div className="md:col-span-2">
            <span className="font-mono-label text-[#8E8B85]">(06) — Preços</span>
          </div>
          <div className="md:col-span-7 reveal">
            <h2 className="font-display-tight text-[44px] md:text-[80px] leading-[0.92] text-[#F5F1E8]">
              Preços <span className="font-serif-italic kinetic-grad">imbatíveis.</span>
            </h2>
          </div>
          <div className="md:col-span-3 md:text-right reveal">
            <p className="text-[15px] text-[#8E8B85] leading-relaxed max-w-[300px] md:ml-auto">
              Sem fidelidade. Sem surpresa. Você escolhe e renova quando quiser.
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-wrap gap-2 reveal">
          <button onClick={() => setTab('social')}
            className={`cursor-hover px-5 py-2.5 rounded-full text-[13px] font-medium tracking-wide transition-all duration-300 border ${
              tab === 'social'
                ? 'bg-[#C8FF61] text-[#0A0B0E] border-[#C8FF61]'
                : 'bg-transparent text-[#F5F1E8] border-white/15 hover:border-white/40'
            }`}>Social Media · mensal</button>
          <button onClick={() => setTab('sites')}
            className={`cursor-hover px-5 py-2.5 rounded-full text-[13px] font-medium tracking-wide transition-all duration-300 border ${
              tab === 'sites'
                ? 'bg-[#C8FF61] text-[#0A0B0E] border-[#C8FF61]'
                : 'bg-transparent text-[#F5F1E8] border-white/15 hover:border-white/40'
            }`}>Sites · pagamento único</button>
        </div>

        {tab === 'social' && (
          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {PLANS.map((p) => (
              <div key={p.id}
                className={`reveal cursor-hover relative rounded-[10px] p-7 flex flex-col justify-between transition-all duration-500 hover:-translate-y-1 ${
                  p.highlight
                    ? 'glass-strong border-[#C8FF61]/60 shadow-[0_30px_80px_-30px_rgba(200,255,97,0.4)]'
                    : 'glass'
                }`}
              >
                {p.highlight && (
                  <span className="absolute -top-3 right-6 px-3 py-1 rounded-full text-[10px] font-bold tracking-[0.18em] uppercase bg-[#C8FF61] text-[#0A0B0E]">
                    + escolhido
                  </span>
                )}
                <div>
                  <span className="font-mono-label text-[#8E8B85]">PLANO</span>
                  <h3 className="mt-2 font-display-tight text-[36px] leading-none text-[#F5F1E8]">{p.name}</h3>
                  <div className="mt-5 flex items-baseline gap-1">
                    <span className={`font-display-tight text-[52px] leading-none ${p.highlight ? 'kinetic-grad' : 'text-[#F5F1E8]'}`}>
                      R${p.price}
                    </span>
                    <span className="text-[13px] text-[#8E8B85]">/mês</span>
                  </div>
                  <p className="mt-4 text-[14px] leading-relaxed text-[#8E8B85]">{p.description}</p>

                  <ul className="mt-6 space-y-3 text-[14px]">
                    <Row label="Posts no mês" value={p.posts} />
                    <Row label="Redes incluídas" value={p.network} />
                    <Row label="Stories" value={p.stories} />
                    <Row label="Reels" value={p.reels} />
                    <Row label="Relatório" value={p.report} />
                  </ul>
                </div>

                <a
                  href={WHATSAPP_LINK(`Olá! Quero contratar o plano ${p.name} (R$${p.price}/mês).`)}
                  target="_blank" rel="noopener noreferrer"
                  className={`cursor-hover mt-7 inline-flex items-center justify-between gap-2 px-5 py-3.5 rounded-full text-[13px] font-semibold border transition-all duration-300 ${
                    p.highlight
                      ? 'bg-[#C8FF61] text-[#0A0B0E] border-[#C8FF61] hover:bg-[#F5F1E8]'
                      : 'bg-transparent text-[#F5F1E8] border-white/20 hover:bg-[#C8FF61] hover:text-[#0A0B0E] hover:border-[#C8FF61]'
                  }`}
                >
                  Escolher {p.name}
                  <ArrowUpRight size={14} />
                </a>
              </div>
            ))}
          </div>
        )}

        {tab === 'sites' && (
          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {SITES_PLANS.map((s) => (
              <div key={s.id}
                className="reveal cursor-hover relative rounded-[10px] p-7 flex flex-col justify-between glass hover:-translate-y-1 transition-all duration-500"
              >
                <div>
                  <span className="font-mono-label text-[#8E8B85]">SITE</span>
                  <h3 className="mt-2 font-display-tight text-[36px] leading-none text-[#F5F1E8]">{s.name}</h3>
                  <div className="mt-5 flex items-baseline gap-1">
                    <span className="font-display-tight text-[52px] leading-none text-[#F5F1E8]">R${s.price}</span>
                    <span className="text-[13px] text-[#8E8B85]">{s.suffix}</span>
                  </div>
                  <p className="mt-4 text-[14px] leading-relaxed text-[#8E8B85]">{s.desc}</p>
                </div>
                <a
                  href={WHATSAPP_LINK(`Quero orçamento de site ${s.name}.`)}
                  target="_blank" rel="noopener noreferrer"
                  className="cursor-hover mt-7 inline-flex items-center justify-between gap-2 px-5 py-3.5 rounded-full text-[13px] font-semibold border bg-[#C8FF61] text-[#0A0B0E] border-[#C8FF61] hover:bg-[#F5F1E8] transition-all duration-300"
                >
                  Pedir orçamento
                  <ArrowUpRight size={14} />
                </a>
              </div>
            ))}
          </div>
        )}

        <p className="mt-8 text-[12px] font-mono-label text-[#8E8B85] reveal">
          * Todos os planos com 1 rodada de ajustes gratuita por lote. Sem fidelidade. Pagamento via PIX, boleto ou cartão.
        </p>
      </div>
    </section>
  );
}

function Row({ label, value }) {
  const isOn = value !== '—';
  return (
    <li className="flex items-center justify-between border-b border-dashed border-white/8 pb-2 last:border-b-0 last:pb-0">
      <span className="text-[#8E8B85]">{label}</span>
      <span className="text-[#F5F1E8] font-medium flex items-center gap-2">
        {typeof value === 'number'
          ? value
          : isOn
          ? <span className="flex items-center gap-1"><Check size={14} className="text-[#C8FF61]" /> {value}</span>
          : <span className="text-[#5C5A55]">—</span>}
      </span>
    </li>
  );
}
